import Link from "next/link";
import * as React from "react";
import { Image } from "react-datocms";

export function BadgeImage({ image, href }) {
    return <div className="protocol-image">
        {href && href.length > 0
            ?
            <Link href={href}>
                <Image data={image} usePlaceholder={false} lazyLoad={false}/>
            </Link>
            : <Image data={image} usePlaceholder={false} lazyLoad={false}/>}
    </div>;
}

export function BadgeText({ text }) {
    return <>
        <span className="badge">{text}</span>
        <style jsx>
            {`
    
    .badge {
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
        border-radius: 9999px;
        white-space: nowrap;
        user-select: none;
        cursor: default;
        background-color: var(--code-border);
        font-size: var(--font-size-2);
        height: 24px;
        padding-right: 12px;
        padding-left: 12px;
    }
    `}
        </style>
    </>;
}
